import * as core from '../../../../../../../core'

import { query } from './edit-award.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.awards.widgets.edit-award',
    description: 'Edit Award',
    name: 'Edit Award',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
